var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Slide from '@material-ui/core/Slide';
import MuiSnackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '../SnackbarContent';
var TransitionLeft = function (props) {
    return React.createElement(Slide, __assign({}, props, { direction: "left" }));
};
/**
 * Kareo wrapped component of the Material-UI Snackbar. The prop API has been limited to props defined in SnackbarProps.
 *
 * Snackbars provide brief messages about app processes.
 *
 * Material-UI Snackbar: [Docs](https://v4.mui.com/components/snackbars/), [API](https://v4.mui.com/api/snackbar/)
 *
 * @storybook: [Snackbar](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-snackbar)
 */
var Snackbar = React.forwardRef(function (_a, ref) {
    var message = _a.message, action = _a.action, type = _a.type, props = __rest(_a, ["message", "action", "type"]);
    return (React.createElement(MuiSnackbar, __assign({ anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, TransitionComponent: TransitionLeft }, props, { ref: ref }),
        React.createElement(SnackbarContent, { message: message, action: action, type: type })));
});
Snackbar.displayName = 'KareoSnackbar';
export default Snackbar;
